import React, { Fragment } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Translate } from 'core/translate';

const ShareTabs = ({
  selectedIndex,
  onSelect,
  emailContent,
  linkContent,
  isLiteRenderMode
}) => {
  return (
    <Fragment>
      {isLiteRenderMode ? (
        <Tabs
          selectedIndex={0}
          onSelect={tabIndex => onSelect(tabIndex)}
          selectedTabClassName="byo-tabs__tab--active">
          <TabList className="byo-tabs__tablist">
            <Tab className="byo-tabs__tab">
              <div className="byo-tabs__tab-label">
                <Translate value="link" />
              </div>
            </Tab>
          </TabList>
          <TabPanel>{linkContent}</TabPanel>
        </Tabs>
      ) : (
        <Tabs
          selectedIndex={selectedIndex}
          onSelect={tabIndex => onSelect(tabIndex)}
          selectedTabClassName="byo-tabs__tab--active">
          <TabList className="byo-tabs__tablist">
            <Tab className="byo-tabs__tab">
              <div className="byo-tabs__tab-label">
                <Translate value="email" />
              </div>
            </Tab>
            <Tab className="byo-tabs__tab">
              <div className="byo-tabs__tab-label">
                <Translate value="link" />
              </div>
            </Tab>
          </TabList>
          <TabPanel>{emailContent}</TabPanel>
          <TabPanel>{linkContent}</TabPanel>
        </Tabs>
      )}
    </Fragment>
  );
};

export default ShareTabs;
